import { useCallback, useState } from "react";

import type { IGoogleAdsCampaignListItem } from "./use-google-ads-campaigns";

interface IUseGoogleAdsCampaignSelectionReturn {
    selectedCampaign: IGoogleAdsCampaignListItem | null;
    selectCampaign: (campaign: IGoogleAdsCampaignListItem) => void;
    resetCampaign: () => void;
}

export const useGoogleAdsCampaignSelection = (): IUseGoogleAdsCampaignSelectionReturn => {
    const [selectedCampaign, setSelectedCampaign] = useState<IGoogleAdsCampaignListItem | null>(null);

    const selectCampaign = useCallback((campaign: IGoogleAdsCampaignListItem) => setSelectedCampaign(campaign), []);
    const resetCampaign = useCallback(() => setSelectedCampaign(null), []);

    return { selectedCampaign, selectCampaign, resetCampaign };
};
